import { render, staticRenderFns } from "./PurchaseReceivingDetailEdit.vue?vue&type=template&id=5e99022e&scoped=true&"
import script from "./PurchaseReceivingDetailEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseReceivingDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e99022e",
  null
  
)

export default component.exports